'use client';

import { BlockComponentModel } from '@/components/cms/types/blok-component';
import {
  Carousel,
  CarouselRenderItemInfo,
} from '@/decodo/components/atoms/Carousel';
import ImageStrapi, {
  ImageStrapiProps,
} from '@/decodo/components/atoms/Image/ImageStrapi';

import { LogoCarousel } from '.';

import { SECTION_NAMES } from '@/components/integrations/trackingScripts/constants';
import { NextImageProps } from '@/decodo/components/atoms/Image';
import { Text } from '@/decodo/components/atoms/Text';
import { ImageCarouselStrapiProps } from '@/features/imageWithCardsCarousel/imageWithCardsCarouselStrapi';
import { BlockWrapper } from '@/features/utils/BlockWrapperDC';
import { cn } from '@/lib/utils';
import { swiperConfig } from './constants';

export type LogoCarouselStrapiProps = {
  title?: string;
  images: ImageStrapiProps[];
};

export function LogoCarouselStrapi({
  block,
  inner,
}: BlockComponentModel<
  LogoCarouselStrapiProps,
  {
    imageProps?: NextImageProps;
  }
>) {
  const { title, images } = block;
  const doubledLogos = images?.concat(images);

  const renderCarouselImage = ({
    item,
  }: CarouselRenderItemInfo<ImageCarouselStrapiProps['image']>) => (
    <LogoCarousel
      {...item}
      logo={
        <ImageStrapi
          block={item}
          inner={{
            classNames: {
              ...inner?.imageProps?.classNames,
              image: cn('h-4', inner?.imageProps?.classNames?.image),
            },
          }}
        />
      }
    />
  );

  return (
    <BlockWrapper
      classNames={{
        // TODO: support for dark mode carousel config in strapi is still non-existent
        root: cn(
          'py-8 md:py-8 md:!py-[60px] bg-base-white dark:bg-base-dark-black'
        ),
        inner: '!max-w-[1440px]',
      }}
      data-tracker-section={SECTION_NAMES.LOGO_CAROUSEL}
    >
      <div className='flex flex-col'>
        <Text className='text-body-s pb-8 md:pb-9 md:text-center'>{title}</Text>
        <Carousel
          renderItem={renderCarouselImage}
          items={doubledLogos}
          config={{
            ...swiperConfig,
            loop: true,
          }}
          sideGradient={false}
          classNames={{ root: '!max-w-[1440px]' }}
        />
      </div>
    </BlockWrapper>
  );
}
